module.exports = __webpack_public_path__ + "static/media/shaolaishanicon.75c50dc8.webp";